import apiService from '../../../core/services/API';
import { environment } from '../../../environments/environment';

export function doAction({ id, action }) {
    return apiService.post({
        url: `${environment.api.feedback.reportedConversations}/${id}/${action}`
    });
}
